<span [ngSwitch]="value">
  <span class="badge bg-success" *ngSwitchCase="'DELIVERED'"> {{'smsStatusValue.'+value | translate}}</span>
  <span class="badge bg-danger" *ngSwitchCase="'ERROR'"> {{'smsStatusValue.'+value | translate}}</span>
  <span class="badge bg-danger" *ngSwitchCase="'NOT_DELIVERED'"> {{'smsStatusValue.'+value | translate}}</span>
  <span class="badge bg-warning" *ngSwitchDefault> {{'smsStatusValue.'+value | translate}}</span>
</span>
